module.exports = __webpack_public_path__ + "static/media/drap.061a855d.mp3";